import Vuex from 'vuex'

window.Vue = require('vue/dist/vue.js')
import axios from 'axios'
import lodash from 'lodash-es'
import moment from 'moment'
import Cookies from 'js-cookie'
import 'moment/locale/fr'
import EventBus from '../event-bus'
import VuexPersistence from 'vuex-persist'
import { getField, updateField } from 'vuex-map-fields'
import { v4 as uuidv4 } from 'uuid'
import i18n from './../i18n.js'
import * as Qs from 'qs'
import requestWP from './request-wp'
import trainees from './modules/trainees'
import registrations from './modules/registrations'
import habilitations from './modules/habilitations'
import monitoring from './modules/monitoring'
import results from './modules/results'
import {
  SET_API_BASEURL,
  SET_API_KEY_INSEE,
  SET_DATA_CLIENT,
  SET_ORDERS_CLIENT,
  SET_DATA_LOCATIONS,
  SET_DATA_NEWSLETTERS,
  SET_COURSE,
  ADD_TO_CART,
  REGISTER_TRAINEE,
  REMOVE_FROM_REGISTRED_LIST,
  RESTORE_MUTATION,
  SET_COUNT,
  UPDATE_QTY,
  QTY_UPP,
  QTY_DOWN,
  SET_STEP,
  SET_CART_UPDATED_AT_DATE,
  IATA_TOGGLE,
  DELETE_TRAINEE,
  ADD_TRAINEE,
  CLEAR_CART,
  SET_COMPANY,
  SET_ESTABLISHMENT,
  SET_COURSES,
  SET_DATA_TO_CLIENT,
} from './mutation-types'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    user: state.user,
    company: state.company,
    establishment: state.establishment,
    establishments: state.establishments,
    maxCount: state.maxCount,
    apiBaseURL: state.apiBaseURL,
    apiKeyINSEE: state.apiKeyINSEE,
    orders: state.orders,
    locations: state.locations,
    quoteCourse: state.quoteCourse,
    quoteLanguage: state.quoteLanguage,
    cart: state.cart,
    step: state.step,
    steps: state.steps,
    tabs: state.tabs,
    newsletters: state.newsletters,
    trainees: {
      filtredTrainee: state.trainees.filtredTrainee,
      limit: state.trainees.limit,
      pagination: state.trainees.pagination,
      selectedTrainees: state.trainees.selectedTrainees,
      trainees: state.trainees.trainees,
    },
  }),
})

export default new Vuex.Store({
  // strict: true,
  modules: {
    trainees,
    registrations,
    habilitations,
    monitoring,
    results,
  },
  state: {
    courses: [],
    company: null,
    establishment: null,
    establishments: [],
    maxCount: 50,
    apiBaseURL: null,
    apiKeyINSEE: null,
    user: null,
    orders: null,
    locations: [],
    quoteCourse: {},
    quoteLanguage: '',
    cart: {
      generatedIdCart: uuidv4(),
      items: [],
      createdAt: moment().format('MMMM Do YYYY, h:mm:ss a'),
      createdBy: '',
      updatedAt: '',
    },
    step: 0,
    steps: [
      'cart-component',
      'identification-component',
      'register-component',
      'payment-component',
    ],
    tabs: [
      i18n.t('cart'),
      i18n.t('identification'),
      i18n.t('registerTrainees'),
      i18n.t('payment'),
    ],
  },
  mutations: {
    updateField,
    [RESTORE_MUTATION]: vuexLocal.RESTORE_MUTATION,
    [SET_COURSES](state, data) {
      state.courses = data
    },
    [SET_API_BASEURL](state, url) {
      state.apiBaseURL = url
    },
    [SET_API_KEY_INSEE](state, key) {
      state.apiKeyINSEE = key
    },
    [SET_DATA_CLIENT](state, payload) {
      state.user = payload.data
      state.cart.createdBy = payload.data.id
    },
    [SET_ORDERS_CLIENT](state, payload) {
      state.orders = payload.data
    },
    [SET_DATA_NEWSLETTERS](state, payload) {
      state.newsletters = payload.data
    },
    [SET_COURSE](state, payload) {
      state.course = payload.data
    },
    [ADD_TO_CART](state, payload) {
      state.cart.items.push(payload)
      EventBus.$emit('cart.add.confirmation')
      state.cart.updatedAt = moment().format('MMMM Do YYYY, h:mm:ss a')
    },
    [REGISTER_TRAINEE](modules, payload) {
      let cartItemId = payload.cartItemId
      let traineeId = payload.traineeId
      let itemIndex = lodash.findIndex(modules.cart.items, (o) => {
        return o.id == cartItemId || !o
      })
      if (itemIndex == -1) {
        return
      }
      let trainee = modules.user.trainees.data.find((o) => {
        return o.id == traineeId
      })
      if (trainee && modules.cart?.items?.length) {
        modules.cart.items[itemIndex].trainees.push(trainee)
        modules.cart.updatedAt = moment().format('MMMM Do YYYY, h:mm:ss a')
      }
    },
    [REMOVE_FROM_REGISTRED_LIST](state, payload) {
      let itemId = payload.itemId
      let traineeIndex = payload.traineeIndex
      let itemIndex = lodash.findIndex(state.cart.items, function (o) {
        return o.id == itemId
      })
      if (itemIndex == -1) {
        return
      }
      if (
        lodash.get(
          state.cart.items[itemIndex],
          'trainees[' + traineeIndex + ']'
        )
      ) {
        let trainee = state.cart.items[itemIndex].trainees[traineeIndex]
        state.cart.items[itemIndex].trainees.splice(traineeIndex, 1)
        EventBus.$emit('trainee.restore', trainee)
        state.cart.updatedAt = moment().format('MMMM Do YYYY, h:mm:ss a')
      }
    },
    [DELETE_TRAINEE](modules, data) {
      let index = lodash.findIndex(modules.trainees.trainees, (i) => {
        i.id === data
      })
      modules.trainees.trainees.splice(index, 1)
    },
    // [UPDATE_PAYEMENT_TYPE](state, type) {
    //   state.cart.paymentType = type
    // },
    [ADD_TRAINEE](modules, trainee) {
      let obj = {
        id: trainee.id ? trainee.id : null,
        gender: trainee.gender ? trainee.gender : 0,
        firstname: trainee.firstname ? trainee.firstname : '',
        lastname: trainee.lastname ? trainee.lastname : '',
        email: trainee.email ? trainee.email : '',
        birthday: trainee.birthday ? trainee.birthday : '',
      }
      console.log('modules.trainees ', modules.trainees)
      console.log('modules ', modules)
      modules.trainees.trainees.push(obj)
    },
    [IATA_TOGGLE](state, data) {
      state.cart.items[data.index].iataChecked = data.value
      let item = state.cart.items[data.index]
      let priceIATA = 0
      if (item.isIATA) {
        priceIATA = item.priceIATA
      }
      let total =
        (parseFloat(priceIATA) + parseFloat(item.price)) *
        parseInt(item.qty).toFixed(2)
      state.cart.items[data.index].total = total
      state.cart.updatedAt = moment().format('MMMM Do YYYY, h:mm:ss a')
    },
    [SET_COUNT](state, data) {
      if (data.value > state.maxCount) data.value = state.maxCount
      state.cart.items[data.n].qty = parseInt(data.value, 10)
      let registeredUsers = state.cart.items[data.n].users.length
      let qty = parseInt(data.value, 10)

      if (registeredUsers > qty)
        state.cart.items[data.n].users.splice(qty, registeredUsers - qty)
    },
    [UPDATE_QTY](state, data) {
      if (data.qty > state.maxCount) data.qty = state.maxCount
      state.cart.items[data.IndexItem].qty += data.qty
      state.cart.updatedAt = moment().format('MMMM Do YYYY, h:mm:ss a')
    },
    [QTY_UPP](state, n) {
      state.cart.items[n].qty++
      if (state.cart.items[n].qty > state.maxCount)
        state.cart.items[n].qty = state.maxCount
      state.cart.updatedAt = moment().format('MMMM Do YYYY, h:mm:ss a')
    },
    [QTY_DOWN](state, n) {
      if (state.cart.items[n].qty > 1) state.cart.items[n].qty--
      else state.cart.items.splice(n, 1)
      state.cart.updatedAt = moment().format('MMMM Do YYYY, h:mm:ss a')
      // let registeredUsers = state.cart.items[n].users.length
      // let qty = state.cart.items[n].qty

      // if (registeredUsers < qty)
    },
    [SET_STEP](state, n) {
      if (n <= state.steps.length - 1) state.step = n
      window.scrollTo(0, 0)
    },
    [SET_CART_UPDATED_AT_DATE](state) {
      state.cart.updatedAt = moment().format('MMMM Do YYYY, h:mm:ss a')
    },
    [CLEAR_CART](state) {
      state.cart.items = []
      state.cart.updatedAt = moment().format('MMMM Do YYYY, h:mm:ss a')
    },
    [SET_COMPANY](state, data) {
      state.company = data
    },
    [SET_ESTABLISHMENT](state, data) {
      state.establishment = data
    },
    [SET_DATA_TO_CLIENT](state, payload) {
      let user = lodash.cloneDeep(state.user)
      user.toClients = { data: payload.data }
      state.user = user
      console.log('state.user.toClient', state.user.toClients)
    },
  },
  actions: {
    syncTraineePasswords({ commit, state }, data = {}) {
      if (data?.traineeId) {
        return axios
          .post(state.apiBaseURL + '/trainees/sync-password/' + data?.traineeId)
          .then((response) => {
            if (lodash.get(response, 'data', false)) {
              return response.data
            } else {
              throw new Error('Impossible de récupérer le stagaire')
            }
          })
      } else {
        throw new Error('Impossible de récupérer le stagaire')
      }
    },
    setContactData({ commit, state }, params = {}) {
      return requestWP({
        url: window.ajaxurl,
        method: 'POST',
        data: Qs.stringify(params),
        transformRrequest: (data) => {
          return data
        },
        success: function (response) {},
        error: function (error) {},
      })
    },
    getInvitetdInformations({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(state.apiBaseURL + '/invitations/' + data)
          .then((response) => {
            if (lodash.get(response, 'data.data', false)) {
              resolve(response.data.data)
            } else resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getToClients({ commit, state }, data) {
      let params = data.params
      return new Promise((resolve, reject) => {
        axios
          .get(state.apiBaseURL + '/to-clients/' + data.id, { params })
          .then((response) => {
            if (lodash.get(response, 'data.data', false)) {
              resolve(response.data.data)
            } else resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    inviteUser({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(state.apiBaseURL + '/invitations', params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    removeCompany({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(state.apiBaseURL + '/company-clients', { data: params })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteTrainee({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(state.apiBaseURL + '/trainees/' + params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deletAccount({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(state.apiBaseURL + '/clients/' + state.user.id)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateUserInformation({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .put(state.apiBaseURL + '/clients/' + state.user.id, params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateToClientInformation({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .put(state.apiBaseURL + '/to-clients/' + params.id, params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    editTrainee({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .put(state.apiBaseURL + '/trainees/' + params.id, params.payload)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    sendQuoteRequest({ commit, state }, params = {}) {
      return requestWP({
        url: window.ajaxurl,
        method: 'POST',
        data: Qs.stringify(params),
        transformRrequest: (data) => {
          return data
        },
        success: function (response) {},
        error: function (error) {},
      })
    },
    updateNewslettersSelection({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            state.apiBaseURL + '/clients/add-newsletters/' + state.user.id,
            params
          )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    signUp({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(state.apiBaseURL + '/clients', params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    changingPassword({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .put(state.apiBaseURL + '/change-password/' + state.user.id, params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    resetPassword({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(state.apiBaseURL + '/clients/reset-password', params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    forgotPassword({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(state.apiBaseURL + '/clients/forgot-password', params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addOrder({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(state.apiBaseURL + '/orders', params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    login({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(state.apiBaseURL + '/clients/login', params)
          .then((response) => {
            let data = response.data.data
            commit('SET_DATA_CLIENT', { data: data })
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addTrainee({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(state.apiBaseURL + '/trainees', params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    importTrainee({ commit, state, rootState }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(rootState.apiBaseURL + '/trainees/import', params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    importRegistration({ commit, state, rootState }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(rootState.apiBaseURL + '/training-plan/import', params)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getCourseItem({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .get(state.apiBaseURL + '/courses/' + params.id)
          .then((response) => {
            if (lodash.get(response, 'data.data')) {
              let data = response.data.data
              commit('SET_COURSE', { data: data })
              resolve(data)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getNewsletters({ commit, state }) {
      return new Promise((resolve, reject) => {
        axios
          .get(state.apiBaseURL + '/newsletters')
          .then((response) => {
            if (lodash.get(response, 'data.data')) {
              let data = response.data.data
              commit('SET_DATA_NEWSLETTERS', { data: data })
              resolve(data)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    AddToClient({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(state.apiBaseURL + '/to-clients', params)
          .then((response) => {
            if (lodash.get(response, 'data.data')) {
              let data = response.data.data
              console.log(data)
              // commit("SET_DATA_CLIENT", { data: data });
              resolve(data)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },

    getAccountInformations({ commit, state }, params) {
      let include = ''
      let includes = params?.includes ?? null
      if (includes === null) {
        // include = 'trainees,newsletters,sessions,toClients.clients'
        include = 'trainees,newsletters,sessions,toClients.clients'
      } else {
        include = includes.join()
      }
      console.log('include', include)
      let data = {}
      if ('' != include) {
        data.include = include
      }
      return new Promise((resolve, reject) => {
        axios
          .get(state.apiBaseURL + '/clients/' + state.user.id, {
            params: data,
          })
          .then((response) => {
            if (lodash.get(response, 'data.data')) {
              let data = response.data.data
              commit('SET_DATA_CLIENT', { data: data })
              resolve(data)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    getTOClientByClientId({ commit, state }, params) {
      let data = { client_id: state.user.id }
      return new Promise((resolve, reject) => {
        axios
          .get(state.apiBaseURL + '/to-clients', {
            params: data,
          })
          .then((response) => {
            if (lodash.get(response, 'data.data')) {
              let data = response.data.data
              commit('SET_DATA_TO_CLIENT', { data: data })
              resolve(data)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    // getUserOrders({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .get(state.apiBaseURL + '/clients/' + state.user.id + '/orders')
    //       .then((response) => {
    //         if (lodash.get(response, 'data.data')) {
    //           let data = response.data.data
    //           commit('SET_ORDERS_CLIENT', { data: data })
    //           resolve(data)
    //         }
    //       })
    //       .catch((error) => {
    //         console.log(error)
    //         reject(error)
    //       })
    //   })
    // },
    getCourses({ commit, state }, data) {
      console.log('data:', data)
      return new Promise((resolve, reject) => {
        axios
          .get(state.apiBaseURL + '/courses', {
            params: data,
          })
          .then((response) => {
            let resp = []
            if (lodash.get(response, 'data.data')) {
              resp = response.data.data
              commit('SET_COURSES', resp)
            }
            resolve(resp)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    getUserOrders({ commit, state }) {
      return new Promise((resolve, reject) => {
        axios
          .get(state.apiBaseURL + '/clients/' + state.user.id + '/orders')
          .then((response) => {
            if (lodash.get(response, 'data.data')) {
              let data = response.data.data
              commit('SET_ORDERS_CLIENT', { data: data })
              resolve(data)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    validateCompanySiret({ commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .get('https://api.insee.fr/entreprises/sirene/V3/siret/' + params, {
            headers: {
              Authorization: 'Bearer ' + state.apiKeyINSEE,
            },
            params: {
              champs: 'siret,siren,nic,denominationUniteLegale',
            },
          })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
  },
  getters: {
    getField,
    isLoggedIn(state, getters) {
      if (lodash.get(state.user, 'id', false)) {
        return true
      }
      return false
    },
    isCartEmpty(state, getters) {
      if (lodash.isEmpty(state.cart.items)) {
        return true
      }
      return false
    },
    subTotalHT: (state) => (id) => {
      let item = state.cart.items.find((thing) => thing.id === id)
      if (item) {
        let isIATA = lodash.get(item, 'iataChecked', false)
        let priceIATA = lodash.get(item, 'priceIATA', 0)
        if (isIATA === true) {
          return (
            (parseFloat(item.price) + parseFloat(priceIATA)) *
            parseInt(item.qty)
          )
        } else {
          return parseFloat(item.price) * parseInt(item.qty)
        }
      }
    },
    totalHT(state, getters) {
      let cart = state.cart
      if (cart.items.length) {
        let totalHT = cart.items.reduce(function (sum, current) {
          var val = parseFloat(getters.subTotalHT(current.id) || 0)
          return sum + val
        }, 0)

        return totalHT.toFixed(2)
      } else {
        return 0
      }
    },
    totalTTC(state, getters) {
      return (
        parseFloat(getters.totalHT) + parseFloat(getters.totalVat)
      ).toFixed(2)
    },
    vatRate(state, getters) {
      if (!state.user) {
        return 0.2
      } else {
        return parseFloat(state.user.vatRate).toFixed(3)
      }
    },
    totalVat(state, getters) {
      return (getters.totalHT * getters.vatRate).toFixed(2)
    },
    vatRateLabel(state, getters) {
      if (!state.user) {
        return '20%'
      } else {
        return state.user.vatRate * 100 + '%'
      }
    },
    registredTrainees: (state, getters) => (cartItemId) => {
      let itemIndex = lodash.findIndex(state.cart.items, function (o) {
        return o.id == cartItemId
      })
      if (itemIndex == -1) {
        return []
      }
      return state.cart.items[itemIndex].trainees
    },
    traineeByIndex: (state, getters) => (cartItemId, traineeIndex) => {
      let itemIndex = lodash.findIndex(state.cart.items, function (o) {
        return o.id == cartItemId
      })
      if (itemIndex == -1) {
        return
      }
      let trainees = getters.registredTrainees(cartItemId)
      if (lodash.get(trainees, '[' + traineeIndex + ']', false)) {
        let trainee = trainees[traineeIndex]
        let firstname = trainee.firstname || '--'
        let lastname = trainee.lastname || '--'
        return lastname + ' ' + firstname
      }
      return '- -'
    },
    checkTraineeRegistration: (state, getters) => (session) => {
      // let trainee = state?.user?.trainees?.data[ 0 ];
      let registrations = lodash.uniqWith(
        state.user.registrations,
        lodash.isEqual
      )
      return registrations.find((r) => r.sessionId == session.id)
    },
  },
  plugins: [vuexLocal.plugin],
})
